

import Vue from 'vue'
import router from './router'

import axios from 'axios'
import App from './App'

import VueLazyload from 'vue-lazyload'

import VeeValidate, { Validator } from 'vee-validate'
import {validaterules, config, dictionary} from '../static/js/customvalidator.js'

import 'url-search-params-polyfill'

import VueTouch from 'vue-touch'

import Loading from 'vux/src/components/loading/index.vue'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


import './common/stylus/index.styl'

import PmsConst from './utils/PmsConst'

import DrawerLayout from 'vue-drawer-layout'
import {eventBus} from './eventbus'

import vueg from 'vueg'
import 'vueg/css/transition-min.css'
import {options} from '../static/js/vuegoptions.js'
Vue.use(vueg, router, options)
Vue.use(DrawerLayout)
Vue.component('loading', Loading)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(PmsConst)
Vue.use(WechatPlugin)

/*  ****************************************** VEE-VALIDATE start ******************************************** */
Vue.use(VeeValidate, config)

Object.keys(validaterules).forEach((key) => {
Validator.extend(key, validaterules[key])
})
Validator.localize(dictionary)
/* **************************************** VEE-VALIDATE end ************************************* */

Vue.config.productionTip = false
/*   *************************************** axios start ********************************* */
axios.interceptors.request.use(
config => {
config.headers.common['Source'] = 'phone'
if (localStorage.JWT_TOKEN) { // 如果存在token，则添加到请求头中
config.headers.Authorization = localStorage.getItem('JWT_TOKEN')
}



config.baseURL = '/pms/'
return config
},
error => {
return Promise.reject(error)
}
)
axios.interceptors.response.use(
response => {
return response
},
error => {
if (error.response) {
switch (error.response.status) {

case 401:
localStorage.removeItem('JWT_TOKEN')
localStorage.removeItem('ID')

eventBus.$emit('showAuthExpire')
break

case 302:
localStorage.removeItem('JWT_TOKEN')
localStorage.removeItem('ID')

router.replace({
path: '/login'
})
break

case 500:

router.replace({
path: '/error'
})
break
}
}
return Promise.reject(error.response.data)
}
)

Vue.prototype.$http = axios
/* *************************************** axios end **************************************** */

/* ************************************** 图片懒加载配置 start *************************************** */
Vue.use(VueLazyload, {
preLoad: 1.1,
error: 'dist/error.png',
loading: '../static/img/loading.gif',
attempt: 3,
listenerEvents: ['touchmove']
})

/* ************************************** 图片懒加载配置 end *************************************** */

router.beforeEach((to, from, next) => {

window.document.title = to.meta.title

if (to.matched.length === 0) {

from.name ? next({ name: from.name }) : next('/doctor/index')
} else {


if (localStorage.getItem('JWT_TOKEN')) {
if (to.name === 'Login') {
next('/doctor/index')
} else {
next()
}
} else {
if (to.name === 'Login' || to.name === 'Forget' || to.name === 'Register' || to.name === 'WaitReview') {
next()
} else {
next('/login')
}
}
}
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js